import { Text } from '@/atoms';

import type { FunctionComponent } from 'react';
import type { TypePriceProps } from './types';

export const Price: FunctionComponent<TypePriceProps> = ({
  className = '',
  price,
  period,
  mark = false,
  unstyled = false,
}: TypePriceProps) => (
  <div className={`flex items-center ${className}`}>
    <Text
      as={mark ? 'mark' : 'p'}
      suppressHydrationWarning={true}
      className={`text-neutrals-900 ${unstyled ? '' : 'text-price'}`}
    >
      {price}
    </Text>
    {period && (
      <Text className="text-body text-body-l text-neutrals-500">{period}</Text>
    )}
  </div>
);

Price.displayName = 'Price';
